// Angular
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// Components 
import { CaseTypesListComponent } from "./case_types/case-types-list/case-types-list.component";
import { LocationTypesListComponent } from "./location-types/location-types-list/location-types-list.component";
import { AddLocationTypesComponent } from "./location-types/add-location-types/add-location-types.component";
import { UpdatePolicyControlComponent } from "./policy_control/update-policy-control/update-policy-control.component";
import { PolicyControlComponent } from "./policy_control/policy-control-list/policy-control-list.component";
import { HelpPlanTypesOverviewComponent } from "./help-plans-types-overview/help-plans-types-overview.component" ;
import { MidOfficeDiagnoseListComponent } from "./MidOfficeDiagnoses/mid-office-diagnose-list/mid-office-diagnose-list.component";
import { CountriesListComponent } from "./Countries/countries-list/countries-list.component";
import { UserAccountListComponent } from "./user-accounts/user-accounts-list/user-accounts-list.component";
import { RolesListComponent } from "./roles/role-list/roles-list.component";
import { TemplateListComponent } from "./Templates/template-list/template-list.component";
import { ActionTypeListComponent } from "./actionTypes/actionType-List/actionType-list.component";
import { MessagesOverviewComponent } from "./messages-overview/messages-overview-list/messages-overview.component";
import { AlphaGuard } from "app/_guards/alpha.guard";
import { ROLES } from "app/_constants/roles";
import { CedProductListComponent } from "./ced-products/ced-product-list/ced-product-list.component";
import { WorkActivityOptionsListComponent } from "./workActivityOptions/work-activity-options-list/work-activity-options-list.component";
import { ServicesComponent } from "./services/services/services.component";

const routes: Routes = [
  {
    path: "",
    data: {
      title: "Management",
      breadcrumbs: "",
    },
    children: [
      {
        path: "roles",
        component: RolesListComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
      {
        path: "user-accounts",
        component: UserAccountListComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
      {
        path: "casetypes",
        component: CaseTypesListComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
      {
        path: "ced-products",
        component: CedProductListComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
        }
      },
      {
        path: "services",
        component: ServicesComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
        }
      },
      {
        path: "location-types-list",
        component: LocationTypesListComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
      {
        path: "add-locationtypes",
        component: AddLocationTypesComponent
      },
      {
        path: "policycontrol",
        component: PolicyControlComponent,
      },
      {
        path: "update-policycontrol/:PCid",
        component: UpdatePolicyControlComponent,
      },
      {
        path: "help-plan-types",
        component: HelpPlanTypesOverviewComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
      {
        path: "help-plan-types-overview",
        component: HelpPlanTypesOverviewComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
      {
        path: "mid-office-types",
        component: MidOfficeDiagnoseListComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
      {
        path : "countries-list",
        component: CountriesListComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
      {
        path : "templates-list",
        component: TemplateListComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
      {
        path : "messagesOverview",
        component: MessagesOverviewComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
      {
        path : "action-types",
        component: ActionTypeListComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
      {
        path: "airlines-list",
        loadChildren: () => import('app/management/Airlines/airline.module').then(m => m.AirlineModule),
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
      {
        path: "airports-list",
        loadChildren: () => import('app/management/Airports/airport.module').then(m => m.AirportModule),
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
      {
        path: "work-activity-options-list",
        component: WorkActivityOptionsListComponent,
        canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS]
          }
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AlphaGuard],
})
export class ManagementRoutingModule { }
